<template #default>
    <form
        v-if="status.detail"
        @submit.prevent="stateUUID ? requestUpdate() : requestCreate()"
    >
        <b-form-group
            :label="$t('module.country')"
            label-cols="4"
            label-align="left"
        >
            <multiselect
                v-model="createForm.country"
                deselect-label="Can't remove this value"
                track-by="value"
                label="text"
                :placeholder="$t('message.pleaseSelectX', [])"
                :options="countryDdl"
                :searchable="true"
                :allow-empty="false"
                :append-to-body="true"
                :class="[submitted && !$v.createForm.country.required ? 'border border-danger' : '']"
            />
            <div v-if="submitted && !$v.createForm.country.required" class="invalid-feedback d-block text-right">
                {{ $t("message.requiredX", [$t("module.country")]) }}
            </div>
        </b-form-group>
        <b-form-group
            :label="$t('label.name')"
            label-cols="4"
            label-align="left"
        >
            <b-form-input
                v-model.trim="createForm.name"
                :class="{ 'is-invalid': submitted && !$v.createForm.name.required }"
                autocomplete="off"
            ></b-form-input>
            <b-form-invalid-feedback v-if="submitted && !$v.createForm.name.required" class="text-right">
                {{ $t("message.requiredX", [$t("label.name")]) }}
            </b-form-invalid-feedback>
        </b-form-group>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end w-100">
            <b-button
                type="button"
                variant="danger"
                class="mr-2 col-2"
                @click="$emit('done')"
            >{{ $t('label.cancel') }}</b-button>
            <b-button
                type="submit"
                variant="info"
                class="col-2"
                :disabled="!status.save"
            >
                <span v-if="status.save">
                    {{ stateUUID ? $t('label.updateX', []) : $t('label.createX', []) }}
                </span>
                <div v-else>
                    <b-spinner small />
                </div>
            </b-button>
        </div>
    </form>
    <div v-else class="d-flex justify-content-center align-items-center m-3">
        <b-spinner class="m-5" variant="info" role="status"></b-spinner>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { stateMethods, lookupMethods } from "@/state/api";
import { STATE_MODULE } from "@/state/api/state.state";

export default {
    props: {
        stateUUID: {
            type: String,
            required: false,
        },
        searchCriteria: {
            type: Object,
            required: false,
        },
    },
    validations() {
        return {
            createForm: {
                name: { required },
                country: { required },
            },
        };
    },
    components: { Multiselect },
    async created() {
        await this.lookupCountry({});
        await this.getStateData();
    },
    data() {
        return {
            submitted: false,
            createForm: this.defaultForm(),
        };
    },
    methods: {
        ...stateMethods,
        ...lookupMethods,
        defaultForm() {
            return {
                uuid: "",
                name: "",
                country: null,
            };
        },
        async getStateData() {
            if (this.stateUUID) {
                await this.getState({ uuid: this.stateUUID })
                    .then((result) => {
                        if (result?.success) {
                            this.createForm = {
                                uuid: this.data.uuid,
                                name: this.data.name,
                                country: this.data.country ? {
                                    value: this.data.country.uuid,
                                    text: this.data.country.name,
                                } : null,
                            };
                        }
                    });
            }
        },
        requestCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    countryUUID: this.createForm.country.value,
                };
                this.createState({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        requestUpdate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    countryUUID: this.createForm.country.value,
                };
                this.updateState({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        resetForm() {
            this.createForm = this.defaultForm();
            this.submitted = false;
            this.$v.$reset();
        },
    },
    computed: {
        ...mapState(STATE_MODULE, ['status']),
        countryDdl() {
            return this.$store.state.api.lookup.countryDdl || [];
        },
        data() {
            return this.$store.state.api.state.details;
        },
    },
}
</script>
